import { createApi,fetchBaseQuery} from "@reduxjs/toolkit/query/react";



export const ContentApi = createApi({
    reducerPath: 'ContentApi',
    baseQuery: fetchBaseQuery({
        baseUrl: "http://localhost:5000",
        credentials: 'include',
        prepareHeaders: (headers, { getState }) => {
            const token = getState().Auth.token;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        }
    }),
    tagTypes: ['Admin'],
    endpoints: (builder) => ({
        addCoach: builder.mutation({
            query: (credentials) => ({
                url: '/panel/admin/createCoach',
                method: 'POST',
                body: { ...credentials }
            })
        }),
        addSlide: builder.mutation({
            query: (data) => ({
                url: '/panel/admin/createSlide',
                method: 'POST', 
                body: { ...data }
            })
        }),
        addPrice: builder.mutation({
            query: (data) => ({
                url: '/panel/admin/createTuition',
                method: 'POST', 
                body: { ...data }
            })
        }),
        fetchContent: builder.query({
            query: () => ({
                url: '/panel/admin/fetchContent',
                method: 'GET'
            })
        }),
    })
});
export const {useAddCoachMutation,useFetchCoachQuery,useAddSlideMutation,useFetchSlideQuery,useAddPriceMutation,useFetchPriceQuery,useAddBlogMutation,useFetchBlogByIdQuery,useFetchBlogQuery,useFetchContentQuery} = ContentApi
